import React from 'react';
import PropTypes from 'prop-types';

import { StyledBone } from './StyledComponents';

const propTypes = {
    type: PropTypes.oneOf([
        'bar', 'line', 'box', 'badge',
    ]),
    cover: PropTypes.bool,
    dark: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    type: 'line',
    dark: false,
    cover: false,
    className: '',
};

const Bone = ({
    dark,
    type,
    cover,
    className,
}) => (
    <StyledBone
        cover={cover}
        light={!dark}
        dark={dark}
        type={type}
        className={className}
    />
);

Bone.propTypes = propTypes;
Bone.defaultProps = defaultProps;

export default Bone;
